const Trombinoscope = ({ members,onDelete = null }) => {
  return (
    <div className="row g-4">
      {members.map((member, index) => (
        <div className="col-12 col-md-6 col-lg-4" key={index}>
          {onDelete && <button 
                className="btn btn-danger btn-sm m-2" 
                onClick={() => {onDelete(member._id)}} 
                style={{ zIndex: 1 }}
              >
                ✕
          </button>}
          <div className="card h-100 shadow-sm border-0 text-center">
            <div className="card-body">
              <img
                src={member.image || "/default-avatar.png"}
                alt={`${member.first_name} ${member.last_name}`}
                className="rounded-circle mb-3"
                style={{ width: 120, height: 120, objectFit: "cover" }}
              />

              <h5 className="fw-semibold mb-1">
                {member.first_name} {member.last_name}
              </h5>

              <p className="text-muted mb-2">
                {member.job}
              </p>

              <a className="mb-1" href={"mailto:"+member.email}>
                📧 {member.email}
              </a>
              <a className="mb-1 d-block" href={"tel:"+member.phone}>
                📞 {member.phone}
              </a>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
export default Trombinoscope;